<template>
  <component
    :is="itemComponent"
    :class="`type-${item.type}`"
    v-bind="{
      ...$props,
      next: item.type === 'conditional_section' ? next?.type : null,
    }"
  />
</template>

<script>
  import UnknownItem from '@/_legacy/views/ChecklistBuilder/Build/Items/UnknownItem.vue';
  import { INSPECTION_ITEM_TYPE } from '@/_legacy/constants';

  const delay = 200;

  const LoadingComponent = {
    render(h) {
      return h('div', { class: 'mx-auto block item-loading' }, 'Loading...');
    }
  };

  const Page = () => ({
    component: import('@/_legacy/views/ChecklistBuilder/Build/Items/Page.vue'),
    loading: LoadingComponent,
    delay,
  });

  const Question = () => ({
    component: import(/* webpackPrefetch: true */ '@/_legacy/views/ChecklistBuilder/Build/Items/Question.vue'),
    loading: LoadingComponent,
    delay,
  });

  const Section = () => ({
    component: import('@/_legacy/views/ChecklistBuilder/Build/Items/Section.vue'),
    loading: LoadingComponent,
    delay,
  });

  const ConditionalSection = () => ({
    component: import('@/_legacy/views/ChecklistBuilder/Build/Items/ConditionalSection.vue'),
    loading: LoadingComponent,
    delay,
  });

  const Action = () => ({
    component: import('@/_legacy/views/ChecklistBuilder/Build/Items/Action.vue'),
    loading: LoadingComponent,
    delay,
  });

  const FormAction = () => ({
    component: import('@/_legacy/views/ChecklistBuilder/Build/Items/FormAction.vue'),
    loading: LoadingComponent,
    delay,
  });

  export default {
    props: {
      item: {
        type: Object,
      },
      next: {
        type: Object,
      },
      parent: {
        type: [Object, String],
      },
      level: {
        type: Number,
      },
      onHeader: {
        type: Boolean,
        default: false,
      },
      onRepeated: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      itemComponent() {
        switch (this.item.type) {
          case INSPECTION_ITEM_TYPE.PAGE:
            return Page;
          case INSPECTION_ITEM_TYPE.SECTION:
            return Section;
          case INSPECTION_ITEM_TYPE.CONDITIONAL:
            return ConditionalSection;
          case INSPECTION_ITEM_TYPE.QUESTION:
            return Question;
          case INSPECTION_ITEM_TYPE.ACTION:
            return Action;
          case INSPECTION_ITEM_TYPE.FORM_ACTION:
            return FormAction;
          default:
            return UnknownItem;
        }
      },
    },
  };
</script>
<style scoped>
  .item-loading {
    width: 100px;
    margin-bottom: 8px;
    margin-top: 8px;
  }
</style>
